<div class="inner-content" *transloco="let t; read: 'paymentModal'" [ngClass]="{'info-block': showInfoBlock}">
    <div class="wrapper" *ngIf="!showInfoBlock">
        <div class="title ion-margin-bottom">
            {{ t('title') }}
        </div>


        <button type="button" class="btn green-btn ion-margin-bottom"
                (click)="byCardOnline()"> {{ t('withCardOnline') }}

            <div class="payment-details" (click)="isApp ? showPopover($event) : null">
                <div class="price-popover d-none ">
                    <div class="info">
                        {{ t('commission') }}
                    </div>
                </div>
                <img src="assets/images/icons/info.svg"/>
            </div>

        </button>


        <button type="button" class="btn btn-primary" (click)="anotherWay()"> {{ t('anotherWay') }}

            <div class="payment-details" (click)="isApp ? showPopover($event) : null">
                <div class="price-popover d-none ">
                    <div class="info">
                        {{ t('commissionFrom1Grn') }}
                    </div>
                </div>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M17.3334 9.00008C17.3334 4.39771 13.6025 0.666748 9.00008 0.666748C4.39771 0.666748 0.666748 4.39771 0.666748 9.00008C0.666748 13.6025 4.39771 17.3334 9.00008 17.3334C13.6025 17.3334 17.3334 13.6025 17.3334 9.00008ZM9.00008 4.20841C9.34526 4.20841 9.62508 4.48824 9.62508 4.83342V9.83342C9.62508 10.1786 9.34526 10.4584 9.00008 10.4584C8.6549 10.4584 8.37508 10.1786 8.37508 9.83342V4.83342C8.37508 4.48824 8.6549 4.20841 9.00008 4.20841ZM9.00008 13.1667C9.46032 13.1667 9.83342 12.7937 9.83342 12.3334C9.83342 11.8732 9.46032 11.5001 9.00008 11.5001C8.53984 11.5001 8.16675 11.8732 8.16675 12.3334C8.16675 12.7937 8.53984 13.1667 9.00008 13.1667Z"
                          fill="#3F403F"/>
                </svg>

            </div>

        </button>


        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>


    </div>

    <div class="wrapper" *ngIf="showInfoBlock">
        <div class="title">
            <div class="green-title">

                {{ t('important') }}

            </div>
            {{ t('bank') }}

        </div>


        <div class="info-list">
            <span> {{ t('chooseTheWay') }}: </span>

            <ul>
                <li>{{ t('booking') }}</li>
                <li>{{ t('payCourse') }}</li>
                <li> {{ t('payMaterial') }}</li>

            </ul>
        </div>


        <div class="info-list">
            <span> {{ t('choosePaymentMethod') }}:</span>

            <ul>
                <li>Google Pay</li>
                <li>Apple Pay</li>
                <li>{{ t('anyBanks') }}</li>

            </ul>
        </div>

        <div class="btn-wrapper">
            <button type="button" class="btn green-btn" (click)="openWebLink()"> {{ t('continue') }}

            </button>
        </div>


        <div class="close" (click)="close()">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8.26035 8.26035C8.60748 7.91322 9.1703 7.91322 9.51743 8.26035L16 14.743L22.4826 8.26041C22.8297 7.91327 23.3925 7.91327 23.7396 8.26041C24.0868 8.60754 24.0868 9.17035 23.7397 9.51749L17.2571 16L23.7396 22.4825C24.0867 22.8296 24.0867 23.3925 23.7396 23.7396C23.3925 24.0867 22.8296 24.0867 22.4825 23.7396L16 17.2571L9.51749 23.7397C9.17036 24.0868 8.60754 24.0868 8.26041 23.7397C7.91328 23.3925 7.91328 22.8297 8.26041 22.4826L14.7429 16L8.26035 9.51743C7.91322 9.1703 7.91322 8.60748 8.26035 8.26035Z"
                      fill="#83B25F"/>
            </svg>
        </div>


    </div>
</div>
